
import React, { useEffect, useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
    Spinner,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
} from "reactstrap";
import { BASE_URL } from "../../utils/constants";
import Swal from "sweetalert2";
import axios from "axios";
import { useSelector } from "react-redux";
import PanelHeader from "components/PanelHeader/PanelHeader";
import { MDBDataTableV5 } from "mdbreact";
import MyBragSheetTable from "./MyBragSheetTable";
import MyBragSheetForm from "./MyBragSheetForm";
import MyBragSheetDataList from "./MyBragSheetDataList";
import MyBragSheetInput from "./MyBragSheetInput";
import MyBragSheetTableInput from "./MyBragSheetTableInput";

import { IconButton } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import MyBragSheetTopCoursesTable from "./MyBragSheetTopCoursesTable";
import MyBragSheetTableAbstract from "./MyBragSheetTableAbstract";
import Select from 'react-select';
import { formatPrintValue } from "../../utils/helperFunc";

export { formatPrintValue };

export const currentDateFunction = () => {
    return new Date().toISOString().slice(0, 10);
}
const printPersonalProfile = (x, myhtml) => {
    // console.log(x)
    const colsFiltered = x.dataCols.filter(y => y.field != "id" && y.field != "action")
    // console.log(colsFiltered)

    myhtml += `
    <div class="no-page-break">
<br/>
    ${x.h5 ? `<h5 class="mt-4">${x.h5}</h5>` : ''}
    ${x.p ? `<p>${x.p}</p>` : ''}
    <table class="table table-striped mt-1 ">
        <thead class="">
            <tr>`;
    colsFiltered.forEach(col => {
        myhtml += `
        <th scope="col">${col.label}</th>

        `;

    });
    myhtml += `
    </tr>
    </thead>
    <tbody>
    `;

    if (!x.dataRows || x.dataRows.length === 0) {
        myhtml += `
        <tr>
            <td colspan="${colsFiltered.length}" class="text-center">-</td>
        </tr>
        `;
    } else {
        x.dataRows.forEach(row => {

            myhtml += `
            <tr>
            `;

            colsFiltered.forEach(col => {
                myhtml += `
                <td>${formatPrintValue(row[col.field])}</td>

                `;


            });
            myhtml += `
            </tr>
            `;

        });
    }

    myhtml += `
        </tbody>
    </table>
    </div>
    `;
    return myhtml;

}
function compareByOrder(a, b) {
    // If a.order is less than b.order, return a negative number
    if (a.myorder < b.myorder) {
        return -1;
    }
    // If a.myorder is greater than b.myorder, return a positive number
    if (a.myorder > b.myorder) {
        return 1;
    }
    // If a.order is equal to b.order, return 0
    return 0;
}

// This function takes an array, an index, and a direction ('left' or 'right')
// and swaps the element at the index with its adjacent element in the given direction
// If the index or the direction is invalid, the function returns the original array
function swap(array, index, direction) {
    // Check if the index is within the array bounds
    if (index < 0 || index >= array.length) {
        return array;
    }
    // Check if the direction is valid
    if (direction !== 'left' && direction !== 'right') {
        return array;
    }
    // Copy the array to avoid mutating the original
    var result = array.slice();
    // Calculate the index of the adjacent element
    var other = direction === 'left' ? index - 1 : index + 1;
    // Check if the other index is within the array bounds
    if (other < 0 || other >= array.length) {
        return array;
    }
    // Swap the elements using destructuring assignment
    [result[index], result[other]] = [result[other], result[index]];
    // Return the swapped array
    return result;
}

const MyBragSheet = () => {
    const [topCourses, setTopCourses] = useState(["A1", "B1", "C1"])

    const createRowsFromCourse = (course, index) => {
        const row =
        {
            rearrenge: (
                <>
                    {
                        0 >= index ? null :
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    setTopCourses(swap(topCourses, index, "left"))
                                }}
                            >
                                <ArrowUpwardIcon fontSize="large" />
                            </IconButton>
                    }
                    {
                        2 <= index ? null :
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    setTopCourses(swap(topCourses, index, "right"))
                                }}
                            >
                                <ArrowDownwardIcon fontSize="large" />
                            </IconButton>
                    }
                </>
            ),
            course: course,
            skills: <input
                type="text"
                name="Skills"
                placeholder="Enter your Skills"
            />,
        }

        return row;
    }
    // const topAcademicCoursesFactory = () => {
    //     return {
    //         columns: [
    //             {
    //                 label: "Rearrenge",
    //                 field: "rearrenge",
    //             },
    //             {
    //                 label: "Course",
    //                 field: "course",
    //                 // width: '20%',
    //             },
    //             {
    //                 label: "Related Skills",
    //                 field: "skills",
    //             },
    //         ],
    //         rows: [...topCourses.map(createRowsFromCourse)]
    //     };
    // }
    // useEffect(() => {
    //     // //// console.log("topCourses")
    //     // //// console.log(topCourses)
    //     setTopAcademicCourses(x => topAcademicCoursesFactory())
    // }, [topCourses])

    const [studentData, setStudentData] = useState({
        user_id: "0",
        firstname: "",
        lastname: "",
        grade: "",
        email: "",
        date: currentDateFunction(),
        mobile: "",
    })
    const extracurricularActivitiesH5 = "Extracurricular Activities"
    const extracurricularActivitiesP = "School activities/club memberships, athletics, etc"
    const [extracurricularActivitiesRows, setExtracurricularActivitiesRows] = useState([
    ])
    const [extracurricularActivities, setExtracurricularActivities] = useState([
        {
            label: "Order",
            field: "id",
            whatType: "textNoEdit",
        },
        {
            label: "Activity Name",
            field: "activity_name",
            whatType: "text",
        },
        {
            label: "Position Held",
            field: "position_held",
            whatType: "text",
            defaultVal: "Member",
        },
        {
            label: "Hours per Week & Academic Years Involved",
            field: "hpwayi",
            whatType: "text",
        },
        {
            label: "Experience & Skills Gained",
            field: "experience",
            whatType: "text",
        },
        {
            label: "Action",
            field: "action",
        },
    ])


    // useEffect(() => {
    //     // console.log("extracurricularActivitiesRows")
    //     // console.log(extracurricularActivitiesRows)

    //     return () => {

    //     }
    // }, [extracurricularActivitiesRows])

    const nonSchoolActivitiesH5 = "Non-School Activities"
    const nonSchoolActivitiesP = "I participated in these activities outside of school."
    const [nonSchoolActivitiesRows, setNonSchoolActivitiesRows] = useState([
    ])
    const [nonSchoolActivities, setNonSchoolActivities] = useState([
        {
            label: "Order",
            field: "id",
            whatType: "textNoEdit",
        },
        {
            label: "Activity Name",
            field: "activity_name",
            whatType: "text",
        },
        {
            label: "Position Held",
            field: "position_held",
            whatType: "text",
        },
        {
            label: "Hours per Week & Academic Years Involved",
            field: "hpwayi",
            whatType: "text",
        },
        {
            label: "Experience & Skills Gained",
            field: "experience",
            whatType: "text",
        },
        {
            label: "Action",
            field: "action",
        },
    ])


    const volunteeringCommunityServiceH5 = "Volunteering/Community Service"
    const volunteeringCommunityServiceP = "These are the ways in which I have given back to the community."
    const [volunteeringCommunityServiceRows, setVolunteeringCommunityServiceRows] = useState([
    ])
    const [volunteeringCommunityService, setVolunteeringCommunityService] = useState([
        {
            label: "Order",
            field: "id",
            whatType: "textNoEdit",
        },
        {
            label: "Name of Organization",
            field: "activity_name",
            whatType: "text",
        },
        {
            label: "Position",
            field: "position_held",
            whatType: "text",
        },
        {
            label: "Service Provided",
            field: "service_provided",
            whatType: "text",
        },
        {
            label: "Hours per Week & Academic Years Involved",
            field: "hpwayi",
            whatType: "text",
        },
        {
            label: "Action",
            field: "action",
        },
    ])

    const topAcademicCoursesH5 = "Top Academic Courses"
    const topAcademicCoursesP = "Top 3 academic courses or subjects in which I excel, and the skills I’ve gained as a result."
    const [courseOptions, setCourseOptions] = useState([])
    const handleSelectCourse = (index, event) => {
        // // console.log("handleSelectCourse")
        // // console.log("index")
        // // console.log(index)
        // // console.log("neq")
        // // console.log(((event.myorder - 1) !== index))
        // // console.log("old")
        // // console.log(courseOptions[index])
        // // console.log("new")
        // // console.log(courseOptions[event.myorder - 1])
        // // console.log("event")
        // // console.log(event)
        const tmp = { ...event };
        courseOptions[event.myorder - 1] = { ...courseOptions[index], myorder: event.myorder }
        courseOptions[index] = { ...tmp, myorder: index + 1 };
        setCourseOptions(x => [...x])
    }
    const handleInputCourseSkill = (index, data, event) => {
        // // console.log("handleInputCourseSkill")
        // // console.log("index")
        // // console.log(index)
        // // console.log("data")
        // // console.log(data)
        // // console.log("event")
        // // console.log(event)
        courseOptions[index].skills = data
        setCourseOptions(x => [...x])
    }

    // useEffect(() => {
    //     // console.log("courseOptions")
    //     // console.log(courseOptions)

    //     return () => {

    //     }
    // }, [courseOptions])

    const [topAcademicCourses, setTopAcademicCourses] = useState({
        columns: [
            {
                label: "Course",
                field: "course",
            },
            {
                label: "Related Skills",
                field: "skills",
            },
        ],
    })

    const academicRecordH5 = "Academic Record"
    const [academicRecordRows, setAcademicRecordRows] = useState([
        { is_editable: true, overall: "", exam: "", },
    ])
    const [academicRecord, setAcademicRecord] = useState([
        {
            label: "Overall GPA",
            field: "overall",
            whatType: "text",
        },
        {
            label: "College Entrance Exam Scores",
            field: "exam",
            whatType: "text",
        },
    ])


    const kuderAssessmentsH5 = "Kuder Assessments"
    const [kuderAssessmentsRows, setKuderAssessmentsRows] = useState([
    ])
    const [kuderAssessments, setKuderAssessments] = useState([
        {
            label: "Order",
            field: "id",
            whatType: "textNoEdit",
        },
        {
            label: "Top 3 Career Pathways",
            field: "career",
            whatType: "text",
        },
        {
            label: "Top 3 Work Values",
            field: "work",
            whatType: "text",
        },
        {
            label: "Holland Code",
            field: "holland",
            whatType: "text",
        },
        {
            label: "Action",
            field: "action",
        },
    ])

    const workExperienceH5 = "Work Experience"
    const workExperienceP = "My current and past employment history."
    const [workExperienceRows, setWorkExperienceRows] = useState([
    ])
    const [workExperience, setWorkExperience] = useState([
        {
            label: "Order",
            field: "id",
            whatType: "textNoEdit",
        },
        {
            label: "Employer",
            field: "employer",
            whatType: "text",
        },
        {
            label: "Job Title",
            field: "job_title",
            whatType: "text",
        },
        {
            label: "Dates (Month & Year)",
            field: "date",
            whatType: "date",
        },
        {
            label: "Action",
            field: "action",
        },
    ])

    const awardsAndHonorsH5 = "Awards and Honors"
    const awardsAndHonorsP = "These are the distinctions I have received."
    const [awardsAndHonorsRows, setAwardsAndHonorsRows] = useState([
    ])
    const [awardsAndHonors, setAwardsAndHonors] = useState([
        {
            label: "Order",
            field: "id",
            whatType: "textNoEdit",
        },
        {
            label: "Name of Award/Honor",
            field: "name",
            whatType: "text",
        },
        {
            label: "Reason for Award",
            field: "reason",
            whatType: "text",
        },
        {
            label: "Date Received",
            field: "date",
            whatType: "date",
        },
        {
            label: "Action",
            field: "action",
        },
    ])

    const topSchoolsH5 = "Top Universities"
    const topSchoolsP = "Top 3 Universities to which I plan to apply:"
    const [topSchoolsRows, setTopSchoolsRows] = useState([
        { is_editable: true, first: "", second: "", third: "", },
    ])
    const [topSchools, setTopSchools] = useState([
        {
            label: "1st Choice",
            field: "first",
            whatType: "text",
        },
        {
            label: "2nd Choice",
            field: "second",
            whatType: "text",
        },
        {
            label: "3rd Choice",
            field: "third",
            whatType: "text",
        },
    ])

    const careerGoalsH5 = "Career Goals"
    const careerGoalsP = "Top 3 careers I can imagine myself pursuing:"
    const [careerGoalsRows, setCareerGoalsRows] = useState([
        { is_editable: true, first: "", second: "", third: "", },
    ])
    const [careerGoals, setCareerGoals] = useState([
        {
            label: "1st Choice",
            field: "first",
            whatType: "text",
        },
        {
            label: "2nd Choice",
            field: "second",
            whatType: "text",
        },
        {
            label: "3rd Choice",
            field: "third",
            whatType: "text",
        },
    ])


    const topAdjectivesH5 = "Top Adjectives"
    const topAdjectivesP = "Top 3 adjectives that best describe me:"
    const [topAdjectivesRows, setTopAdjectivesRows] = useState([
        { is_editable: true, first: "", second: "", third: "", },
    ])
    const [topAdjectives, setTopAdjectives] = useState([
        {
            label: "1st Adjective",
            field: "first",
            whatType: "text",
        },
        {
            label: "2nd Adjective",
            field: "second",
            whatType: "text",
        },
        {
            label: "3rd Adjective",
            field: "third",
            whatType: "text",
        },
    ])

    const topAccomplishmentsH5 = "Top Accomplishments"
    const topAccomplishmentsP = "Top 3 accomplishments in high school:"
    const [topAccomplishmentsRows, setTopAccomplishmentsRows] = useState([
        { is_editable: true, first: "", second: "", third: "", },
    ])
    const [topAccomplishments, setTopAccomplishments] = useState([
        {
            label: "1st Accomplishment",
            field: "first",
            whatType: "text",
        },
        {
            label: "2nd Accomplishment",
            field: "second",
            whatType: "text",
        },
        {
            label: "3rd Accomplishment",
            field: "third",
            whatType: "text",
        },
    ])

    const adultsP = "These are 5 adults who know me and would speak highly of me:"
    const [adultsRows, setAdultsRows] = useState([
    ])
    const [adults, setAdults] = useState([
        {
            label: "Order",
            field: "id",
            whatType: "textNoEdit",
        },
        {
            label: "First & Last Name",
            field: "name",
            whatType: "text",
        },
        {
            label: "Position",
            field: "position",
            whatType: "text",
        },
        {
            label: "Relationship in My Life",
            field: "relationship",
            whatType: "text",
        },
        {
            label: "Contact Information",
            field: "contact",
            whatType: "text",
        },
        {
            label: "Action",
            field: "action",
        },
    ])

    const futurePlansP = "Check any of the following which apply:"
    const [futurePlansRows, setFuturePlansRows] = useState([
        { is_editable: true, check: false, plan: "College", details: "", },
        { is_editable: true, check: false, plan: "Vocational School", details: "", },
        { is_editable: true, check: false, plan: "Apprenticeship Program", details: "", },
        { is_editable: true, check: false, plan: "Intermediate Employment", details: "", },
        { is_editable: true, check: false, plan: "Armed Services", details: "", },
    ])
    const [futurePlans, setFuturePlans] = useState([
        {
            label: "Check",
            field: "check",
            whatType: "checkbox",
        },
        {
            label: "Plan",
            field: "plan",
            whatType: "textNoEdit",
        },
        {
            label: "Details",
            field: "details",
            whatType: "text",
        },
    ])

    const positiveThingsHeadLine = "Positive things that my friends, teachers, and coworkers would say about me:"
    const [positiveThings, setPositiveThings] = useState("")
    const plansHeadLine = "Here is how my attitude and skills will help me be academically successful in my post-high school plans:"
    const [plans, setPlans] = useState("")
    const passionHeadLine = "What I’m passionate about and why:"
    const [passion, setPassion] = useState("")
    const specialTalentsHeadLine = "Special talents, hobbies, interests, or travel experiences that have influenced me:"
    const [specialTalents, setSpecialTalents] = useState("")
    const additionalFactsHeadLine = "Here are some additional facts and details about me that may be helpful for you to know as a letter of recommendation writer:"
    const [additionalFacts, setAdditionalFacts] = useState("")
    const complimentaryLetterHeadLine = "Here is a paragraph that would be appropriate to be included in an accurate and complimentary letter about me:"
    const [complimentaryLetter, setComplimentaryLetter] = useState("")
    // to remove the pagination
    useEffect(() => {
        const entries = document.querySelectorAll('[data-test="datatable"]');
        entries.forEach(element => {
            const row = element.lastChild;
            row.style.display = 'none';
        });
    }, []);


    useEffect(async () => {
        Swal.showLoading();

        axios.get(`${BASE_URL}/bragsheet/getbragsheet.php`)
            .then(res => {
                Swal.close();
                //// console.log("res");
                //// console.log(res);
                const res_data = res?.data?.data;
                //// console.log("res_data");
                //// console.log(res_data);
                if (res_data) {
                    studentData.firstname = res_data.firstname || "";
                    studentData.lastname = res_data.lastname || "";
                    studentData.grade = res_data.grade || "";
                    studentData.email = res_data.email || "";
                    studentData.mobile = res_data.mobile || "";
                    studentData.user_id = res_data.user_id;
                    // studentData.date=res_data.bs.date;
                    setStudentData(x => ({ ...x }))
                    const tmp_courseOptions = (res_data.academiccourses || []).map(x => ({ skills: "", ...x, value: x.id, label: x.name }))
                    tmp_courseOptions.sort(compareByOrder);
                    setCourseOptions(tmp_courseOptions)

                    // setTopAcademicCourses(x => ({ ...x }))
                    setExtracurricularActivitiesRows(res_data.extracurricularactivities || [])
                    setNonSchoolActivitiesRows(res_data.nonschoolactivities || [])
                    setVolunteeringCommunityServiceRows(res_data.volunteeringcommunityservices || [])
                    setKuderAssessmentsRows(res_data.kuderassessments || [])
                    setWorkExperienceRows(res_data.workexperiences || [])
                    setAwardsAndHonorsRows(res_data.awardhonors || [])
                    setAdultsRows(res_data.adults || [])
                    // setAcademicRecordTable(x => ({ ...x, rows: [{ overall: res_data.gpa, exam: res_data.college_exam }] }))
                    futurePlansRows.forEach(element => {
                        const plan = element.plan.split(" ").join("").toLowerCase();
                        // // console.log("element.check")
                        // // console.log(element.check)
                        let key = `${plan}check`
                        if (res_data.bs && res_data.bs.hasOwnProperty(key)) {
                            element.check = !!(res_data.bs[key] - 0)
                        }
                        key = `${plan}details`
                        if (res_data.bs && res_data.bs.hasOwnProperty(key)) {
                            const tpm_input_value = res_data.bs[key]
                            if (tpm_input_value) element.details = tpm_input_value;
                        }
                        // element.check = !!(res_data.bs[`${plan}check`] - 0)
                        // element.details = res_data.bs[`${plan}details`]
                        // // console.log("plan")
                        // // console.log(plan)
                        // // console.log("element.check")
                        // // console.log(element.check)
                    });
                    setFuturePlansRows(x => [...x])
                    if (res_data.bs && res_data.bs.hasOwnProperty("overall")) {
                        if (res_data.bs.overall) {
                            academicRecordRows[0].overall = res_data.bs.overall || ""
                            academicRecordRows[0].exam = res_data.bs.exam || ""
                            setAcademicRecordRows(x => [...x])
                        }
                        if (res_data.bs.hasOwnProperty("topunifirst")) {
                            topSchoolsRows[0].first = res_data.bs.topunifirst || ""
                            topSchoolsRows[0].second = res_data.bs.topunisecond || ""
                            topSchoolsRows[0].third = res_data.bs.topunithird || ""
                            setTopSchoolsRows(x => [...x])
                        }
                        if (res_data.bs.hasOwnProperty("careergoalsfirst")) {
                            careerGoalsRows[0].first = res_data.bs.careergoalsfirst || ""
                            careerGoalsRows[0].second = res_data.bs.careergoalssecond || ""
                            careerGoalsRows[0].third = res_data.bs.careergoalsthird || ""
                            setCareerGoalsRows(x => [...x])
                        }
                        if (res_data.bs.hasOwnProperty("topadjectivesfirst")) {
                            topAdjectivesRows[0].first = res_data.bs.topadjectivesfirst || ""
                            topAdjectivesRows[0].second = res_data.bs.topadjectivessecond || ""
                            topAdjectivesRows[0].third = res_data.bs.topadjectivesthird || ""
                            setTopAdjectivesRows(x => [...x])
                        }
                        if (res_data.bs.hasOwnProperty("topaccomplishmentsfirst")) {
                            topAccomplishmentsRows[0].first = res_data.bs.topaccomplishmentsfirst || ""
                            topAccomplishmentsRows[0].second = res_data.bs.topaccomplishmentssecond || ""
                            topAccomplishmentsRows[0].third = res_data.bs.topaccomplishmentsthird || ""
                            setTopAccomplishmentsRows(x => [...x])
                        }
                        if (res_data.bs.hasOwnProperty("positivethings")) {
                            setPositiveThings(res_data.bs.positivethings || "")
                        }
                        if (res_data.bs.hasOwnProperty("plans")) {
                            setPlans(res_data.bs.plans || "")
                        }
                        if (res_data.bs.hasOwnProperty("passion")) {
                            setPassion(res_data.bs.passion || "")
                        }
                        if (res_data.bs.hasOwnProperty("specialtalents")) {
                            setSpecialTalents(res_data.bs.specialtalents || "")
                        }
                        if (res_data.bs.hasOwnProperty("additionalfacts")) {
                            setAdditionalFacts(res_data.bs.additionalfacts || "")
                        }
                        if (res_data.bs.hasOwnProperty("complimentaryletter")) {
                            setComplimentaryLetter(res_data.bs.complimentaryletter || "")
                        }
                    }
                }
            }).catch(err => {
                Swal.fire("Something Went Wrong", "", "error");
            })
    }, []);

    const saveFunction = async (data) => {
        Swal.showLoading();

        const currentDate = currentDateFunction();
        axios.post(`${BASE_URL}/bragsheet/setbragsheet.php`, { ...data, date: currentDate, user_id: studentData.user_id })
            .then(res => {
                // const res_data = res?.data?.data;
                // if (res_data != null) {
                // }
                setStudentData(x => ({
                    ...x, date: currentDate
                }))
                Swal.fire("Saved Successfully", "", "success");
            }).catch(err => {
                Swal.fire("Something Went Wrong", "", "error");
            })
    }

    useEffect(() => {
        // console.log("nonSchoolActivitiesRows")
        // console.log(nonSchoolActivitiesRows)

    }, [nonSchoolActivitiesRows])

    return (
        <>
            <PanelHeader size="sm" />
            <div className="content">
                <Row>
                    <Col md={12}>
                        <Card className="w-100">
                            <CardHeader>
                                <h4 className="title">My Brag Sheet</h4>
                            </CardHeader>
                            <CardBody className="all-icons">
                                <div className="text-center d-flex">
                                    <button
                                        className="btn btn-primary fw-bolder mx-auto w-25"
                                        onClick={_ => {
                                            // console.log("Print")
                                            // studentData

                                            // var mywindow = window.open('', '_blank');
                                            var mywindow = window.open();
                                            mywindow.document.write(`
                                            <!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Brag Sheet</title>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
    <style>
    @media print {
        .no-page-break {
          page-break-inside: avoid;
        }
        .breakbefore{
            page-break-before: always;

        }
        p{
          
      margin-bottom: 0 !important;
        }
        th{
          
      font-size: 0.85rem !important;
        }
      }
    </style>
      
</head>

<body>
<div class="">
`);
                                            const studentFullName = [studentData.firstname, studentData.lastname]
                                                .map(name => formatPrintValue(name, ""))
                                                .filter(Boolean)
                                                .join(" ") || "-";

                                            let myhtml = `
                                            
                                            <h4 class="mt-4">Personal Profile</h4>
                                    
        <table class="table table-striped mt-4">
        <thead class="">
            <tr>
                <th scope="col">Full Name</th>
                <th scope="col">Grade Level</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>${studentFullName}</td>
                <td>${formatPrintValue(studentData.grade)}</td>
            </tr>
        </tbody>
    </table>
    <table class="table table-striped mt-4">
        <thead class="">
            <tr>
                <th scope="col">Email Address</th>
                <th scope="col">Phone Number</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>${formatPrintValue(studentData.email)}</td>
                <td>${formatPrintValue(studentData.mobile)}</td>
            </tr>
        </tbody>
    </table>
                                            `;

                                            // Personal Profile : from extracurricularActivities -> Awards and Honors
                                            // top curses !!!!!!!!!!!!!!


                                            [
                                                { h5: extracurricularActivitiesH5, p: extracurricularActivitiesP, dataCols: extracurricularActivities, dataRows: extracurricularActivitiesRows },
                                                { h5: nonSchoolActivitiesH5, p: nonSchoolActivitiesP, dataCols: nonSchoolActivities, dataRows: nonSchoolActivitiesRows },
                                                { h5: volunteeringCommunityServiceH5, p: volunteeringCommunityServiceP, dataCols: volunteeringCommunityService, dataRows: volunteeringCommunityServiceRows },
                                                { h5: topAcademicCoursesH5, p: topAcademicCoursesP, dataCols: topAcademicCourses.columns, dataRows: courseOptions.slice(0, 3).map(co => ({ ...co, [topAcademicCourses.columns[0].field]: co.name })) },
                                                { h5: academicRecordH5, p: "", dataCols: academicRecord, dataRows: academicRecordRows },
                                                { h5: kuderAssessmentsH5, p: "", dataCols: kuderAssessments, dataRows: kuderAssessmentsRows },
                                                { h5: workExperienceH5, p: workExperienceP, dataCols: workExperience, dataRows: workExperienceRows },
                                                { h5: awardsAndHonorsH5, p: awardsAndHonorsP, dataCols: awardsAndHonors, dataRows: awardsAndHonorsRows },

                                            ].forEach(x => {
                                                // console.log(x)
                                                myhtml = printPersonalProfile(x, myhtml)
                                            });

                                            // Future Plans : from Future Plans -> Career Goals
                                            myhtml += `

                                            <h4 class="mt-4">Future Plans</h4>
                                    
                                            `;
                                            [
                                                { h5: "", p: futurePlansP, dataCols: futurePlans.filter(fp=>fp.field!=="check"), dataRows: futurePlansRows.filter(fp=>fp.check) },
                                                { h5: topSchoolsH5, p: topSchoolsP, dataCols: topSchools, dataRows: topSchoolsRows },
                                                { h5: careerGoalsH5, p: careerGoalsP, dataCols: careerGoals, dataRows: careerGoalsRows },
                                            ].forEach(x => {
                                                // console.log(x)
                                                myhtml = printPersonalProfile(x, myhtml)
                                            });


                                            // Personal Details : from Top Adjectives -> adults 
                                            myhtml += `

                                            <h4 class="mt-4">Personal Details</h4>
                                    
                                            `;
                                            [
                                                { h5: topAdjectivesH5, p: topAdjectivesP, dataCols: topAdjectives, dataRows: topAdjectivesRows },
                                                { h5: topAccomplishmentsH5, p: topAccomplishmentsP, dataCols: topAccomplishments, dataRows: topAccomplishmentsRows },
                                                { h5: "", p: adultsP, dataCols: adults, dataRows: adultsRows },
                                            ].forEach(x => {
                                                // console.log(x)
                                                myhtml = printPersonalProfile(x, myhtml)
                                            });
                                            myhtml += `

                                            <div class="breakbefore" />
                                    
                                            `;
            
                                            // inputs
                                            [
                                                { data: positiveThings, headLine: positiveThingsHeadLine },
                                                { data: plans, headLine: plansHeadLine },
                                                { data: passion, headLine: passionHeadLine },
                                                { data: specialTalents, headLine: specialTalentsHeadLine },
                                                { data: additionalFacts, headLine: additionalFactsHeadLine },
                                                { data: complimentaryLetter, headLine: complimentaryLetterHeadLine },
                                            ].forEach(x => {
                                                // console.log(x)
                                                myhtml += `
                                                <br/>

                                                <table class="table  mt-4 no-page-break">
                                                <thead class="">
                                                    <tr>
                                                        <th scope="col">${x.headLine}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style="white-space: pre-wrap;">${formatPrintValue(x.data)}</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                                `;
                                            });


                                            mywindow.document.write(myhtml);
                                            mywindow.document.write(`
                                            </div>
</body>

</html>
`);
                                            // mywindow.document.close(); // necessary for IE >= 10
                                            // mywindow.onload = function() {
                                            //     mywindow.focus(); // necessary for IE >= 10
                                            //     mywindow.print();
                                            //     mywindow.close();
                                            //   };
                                            setTimeout(() => {
                                                mywindow.focus(); // necessary for IE >= 10
                                                mywindow.print();
                                                mywindow.close();
                                            }, 10);
                                            // mywindow.focus(); // necessary for IE >= 10
                                            // mywindow.print();
                                            // mywindow.close();
                                            return true;
                                        }}
                                    >
                                        Print
                                    </button>
                                </div>

                                <h4>
                                    Personal Profile
                                </h4>

                                <MyBragSheetForm
                                    studentData={studentData}
                                    setStudentData={setStudentData}
                                />
                                <MyBragSheetTableAbstract
                                    id={"extracurricularActivities"}
                                    dataCols={extracurricularActivities}
                                    dataRows={extracurricularActivitiesRows}
                                    setDataRows={setExtracurricularActivitiesRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "extracurricularActivities", data: extracurricularActivitiesRows, })
                                    }}
                                    editable={true}
                                >
                                    <h5>
                                        {extracurricularActivitiesH5}
                                    </h5>
                                    <p>
                                        {extracurricularActivitiesP}
                                    </p>
                                </MyBragSheetTableAbstract>

                                <MyBragSheetTableAbstract
                                    id={"nonSchoolActivities"}
                                    dataCols={nonSchoolActivities}
                                    dataRows={nonSchoolActivitiesRows}
                                    setDataRows={setNonSchoolActivitiesRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "nonSchoolActivities", data: nonSchoolActivitiesRows, })
                                    }}
                                    editable={true}
                                >
                                    <h5>
                                        {nonSchoolActivitiesH5}
                                    </h5>
                                    <p>
                                        {nonSchoolActivitiesP}
                                    </p>
                                </MyBragSheetTableAbstract>

                                <MyBragSheetTableAbstract
                                    id={"volunteeringCommunityService"}
                                    dataCols={volunteeringCommunityService}
                                    dataRows={volunteeringCommunityServiceRows}
                                    setDataRows={setVolunteeringCommunityServiceRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "volunteeringCommunityService", data: volunteeringCommunityServiceRows, })
                                    }}
                                    editable={true}
                                >
                                    <h5>
                                        {volunteeringCommunityServiceH5}
                                    </h5>
                                    <p>
                                        {volunteeringCommunityServiceP}
                                    </p>
                                </MyBragSheetTableAbstract>

                                <MyBragSheetTopCoursesTable
                                    id={"topAcademicCourses"}
                                    data={topAcademicCourses}
                                    setData={setTopAcademicCourses}
                                    courseOptions={courseOptions}
                                    handleSelectCourse={handleSelectCourse}
                                    handleInputCourseSkill={handleInputCourseSkill}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "topAcademicCourses", data: courseOptions, })
                                    }}
                                    editable={false}
                                >
                                    <h5>
                                        {topAcademicCoursesH5}
                                    </h5>
                                    <p>
                                        {topAcademicCoursesP}
                                    </p>
                                </MyBragSheetTopCoursesTable>

                                <MyBragSheetTableAbstract
                                    id={"academicRecord"}
                                    dataCols={academicRecord}
                                    dataRows={academicRecordRows}
                                    setDataRows={setAcademicRecordRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "academicRecord", data: academicRecordRows, })
                                    }}
                                    editable={false}
                                >
                                    <h5>
                                        {academicRecordH5}
                                    </h5>
                                </MyBragSheetTableAbstract>

                                <MyBragSheetTableAbstract
                                    id={"kuderAssessments"}
                                    dataCols={kuderAssessments}
                                    dataRows={kuderAssessmentsRows}
                                    setDataRows={setKuderAssessmentsRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "kuderAssessments", data: kuderAssessmentsRows, })
                                    }}
                                    editable={true}
                                >
                                    <h5>
                                        {kuderAssessmentsH5}
                                    </h5>
                                </MyBragSheetTableAbstract>

                                <MyBragSheetTableAbstract
                                    id={"workExperience"}
                                    dataCols={workExperience}
                                    dataRows={workExperienceRows}
                                    setDataRows={setWorkExperienceRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "workExperience", data: workExperienceRows, })
                                    }}
                                    editable={true}
                                >
                                    <h5>
                                        {workExperienceH5}
                                    </h5>
                                    <p>
                                        {workExperienceP}
                                    </p>
                                </MyBragSheetTableAbstract>

                                <MyBragSheetTableAbstract
                                    id={"awardsAndHonors"}
                                    dataCols={awardsAndHonors}
                                    dataRows={awardsAndHonorsRows}
                                    setDataRows={setAwardsAndHonorsRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "awardsAndHonors", data: awardsAndHonorsRows, })
                                    }}
                                    editable={true}
                                >
                                    <h5>
                                        {awardsAndHonorsH5}
                                    </h5>
                                    <p>
                                        {awardsAndHonorsP}
                                    </p>
                                </MyBragSheetTableAbstract>

                                <h4>
                                    Future Plans
                                </h4>
                                <MyBragSheetTableAbstract
                                    id={"futurePlans"}
                                    dataCols={futurePlans}
                                    dataRows={futurePlansRows}
                                    setDataRows={setFuturePlansRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "futurePlans", data: futurePlansRows, })
                                    }}
                                    editable={false}
                                >
                                    <p>
                                        {futurePlansP}
                                    </p>
                                </MyBragSheetTableAbstract>

                                <MyBragSheetTableAbstract
                                    id={"topSchools"}
                                    dataCols={topSchools}
                                    dataRows={topSchoolsRows}
                                    setDataRows={setTopSchoolsRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "topSchools", data: topSchoolsRows, })
                                    }}
                                    editable={false}
                                >
                                    <h5>
                                        {topSchoolsH5}
                                    </h5>
                                    <p>
                                        {topSchoolsP}
                                    </p>
                                </MyBragSheetTableAbstract>

                                <MyBragSheetTableAbstract
                                    id={"careerGoals"}
                                    dataCols={careerGoals}
                                    dataRows={careerGoalsRows}
                                    setDataRows={setCareerGoalsRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "careerGoals", data: careerGoalsRows, })
                                    }}
                                    editable={false}
                                >
                                    <h5>
                                        {careerGoalsH5}
                                    </h5>
                                    <p>
                                        {careerGoalsP}
                                    </p>
                                </MyBragSheetTableAbstract>


                                <h4>
                                    Personal Details
                                </h4>

                                <MyBragSheetTableAbstract
                                    id={"topAdjectives"}
                                    dataCols={topAdjectives}
                                    dataRows={topAdjectivesRows}
                                    setDataRows={setTopAdjectivesRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "topAdjectives", data: topAdjectivesRows, })
                                    }}
                                    editable={false}
                                >
                                    <h5>
                                        {topAdjectivesH5}
                                    </h5>
                                    <p>
                                        {topAdjectivesP}
                                    </p>
                                </MyBragSheetTableAbstract>

                                <MyBragSheetTableAbstract
                                    id={"topAccomplishments"}
                                    dataCols={topAccomplishments}
                                    dataRows={topAccomplishmentsRows}
                                    setDataRows={setTopAccomplishmentsRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "topAccomplishments", data: topAccomplishmentsRows, })
                                    }}
                                    editable={false}
                                >
                                    <h5>
                                        {topAccomplishmentsH5}
                                    </h5>
                                    <p>
                                        {topAccomplishmentsP}
                                    </p>
                                </MyBragSheetTableAbstract>

                                <MyBragSheetTableAbstract
                                    id={"adults"}
                                    dataCols={adults}
                                    dataRows={adultsRows}
                                    setDataRows={setAdultsRows}
                                    saveFlag={true}
                                    saveFunction={() => {
                                        saveFunction({ name: "adults", data: adultsRows, })
                                    }}
                                    editable={true}
                                >
                                    <p>
                                        {adultsP}
                                    </p>
                                </MyBragSheetTableAbstract>

                                <MyBragSheetInput
                                    data={positiveThings}
                                    setData={setPositiveThings}
                                    saveFunction={() => {
                                        const data = {
                                            name: "positiveThings",
                                            data: positiveThings,
                                        }
                                        //// console.log(data)
                                        saveFunction(data)
                                    }}
                                    name={"positiveThings"}
                                    headLine={positiveThingsHeadLine}
                                />
                                <MyBragSheetInput
                                    data={plans}
                                    setData={setPlans}
                                    saveFunction={() => {
                                        const data = {
                                            name: "plans",
                                            data: plans,
                                        }
                                        //// console.log(data)
                                        saveFunction(data)
                                    }}
                                    name={"plans"}
                                    headLine={plansHeadLine}
                                />
                                <MyBragSheetInput
                                    data={passion}
                                    setData={setPassion}
                                    saveFunction={() => {
                                        const data = {
                                            name: "passion",
                                            data: passion,
                                        }
                                        //// console.log(data)
                                        saveFunction(data)
                                    }}
                                    name={"passion"}
                                    headLine={passionHeadLine}
                                />
                                <MyBragSheetInput
                                    data={specialTalents}
                                    setData={setSpecialTalents}
                                    saveFunction={() => {
                                        const data = {
                                            name: "specialTalents",
                                            data: specialTalents,
                                        }
                                        //// console.log(data)
                                        saveFunction(data)
                                    }}
                                    name={"specialTalents"}
                                    headLine={specialTalentsHeadLine}
                                />
                                <MyBragSheetInput
                                    data={additionalFacts}
                                    setData={setAdditionalFacts}
                                    saveFunction={() => {
                                        const data = {
                                            name: "additionalFacts",
                                            data: additionalFacts,
                                        }
                                        //// console.log(data)
                                        saveFunction(data)
                                    }}
                                    name={"additionalFacts"}
                                    headLine={additionalFactsHeadLine}
                                />
                                <MyBragSheetInput
                                    data={complimentaryLetter}
                                    setData={setComplimentaryLetter}
                                    saveFunction={() => {
                                        const data = {
                                            name: "complimentaryLetter",
                                            data: complimentaryLetter,
                                        }
                                        //// console.log(data)
                                        saveFunction(data)
                                    }}
                                    name={"complimentaryLetter"}
                                    headLine={complimentaryLetterHeadLine}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>


        </>
    )
}

export default MyBragSheet